import React from "react";

import { Row, Col } from "react-bootstrap";

import {
  DefaultColumnWidth,
  DefaultDateColumnWidth,
} from "shared/components/grids/constants/KendoGridAndColumnConstants";

import { GridColumn } from "@progress/kendo-react-grid";

import SharedMainSelectableClientGrid from "shared/components/grids/clientGrid/SharedMainSelectableClientGrid";

export default function AdminRxLookupGrid({
  setShowDetailsModal,
  setSelectedRxNumber,
  setSelectedClaimId,
  setSelectedPaymentId,
  submittedFormData,
  setDetailError,
  gridDataStateResetProcessingInitiated,
  onGridDataStateResetCompleted,
}) {
  let defaultColumnWidth = DefaultColumnWidth();

  const GridViewDetailActionCell = (props) => {
    async function editClick() {
      setShowDetailsModal(true);

      setSelectedRxNumber(props.dataItem["rxNumber"]);
      setSelectedClaimId(props.dataItem["claimId"]);
      setSelectedPaymentId(props.dataItem["paymentId"]);
    }

    return (
      <td className="noWrap" {...props.style}>
        <a
          onClick={editClick}
          style={{
            cursor: "pointer",
            textDecoration: "underline",
            color: "#015CAB",
          }}
        >
          View Details
        </a>
      </td>
    );
  };

  return (
    <Row>
      <Col className="tight-grid multi-line-filter">
        <br />

        <SharedMainSelectableClientGrid
          apiGetEndpoint={"api/AdminRxLookup/GetRxLookupResult"}
          apiParameters={submittedFormData}
          exportFileNamePrefix={"AdminRxLookup"}
          gridErrorHandlerCallback={setDetailError}
          gridDataStateResetProcessingInitiated={
            gridDataStateResetProcessingInitiated
          }
          onGridDataStateResetCompleted={onGridDataStateResetCompleted}
        >
          <GridColumn
            field=""
            title="Action"
            filterable={false}
            sortable={false}
            groupable={false}
            cells={{ data: GridViewDetailActionCell }}
            width={DefaultColumnWidth()}
          />

          <GridColumn field="ncpdp" title="NCPDP" width={defaultColumnWidth} />

          <GridColumn
            field="npi"
            title="Internal NPI"
            width={defaultColumnWidth}
          />

          <GridColumn
            field="dataNpi"
            title="Data NPI"
            width={defaultColumnWidth}
          />

          <GridColumn
            field="memberName"
            title="Pharmacy Name"
            width={defaultColumnWidth * 2} // lets give this one a little more space to try to prevent wrapping on entire row
          />

          <GridColumn
            field="payerName"
            title="Payer"
            width={defaultColumnWidth * 2} // lets give this one a little more space to try to prevent wrapping on entire row
          />

          <GridColumn field="bin" title="BIN" width={defaultColumnWidth} />

          <GridColumn field="pcn" title="PCN" width={defaultColumnWidth} />

          <GridColumn
            field="groupName"
            title="Group"
            width={defaultColumnWidth}
          />

          <GridColumn
            field="rxNumber"
            title="Rx Number"
            width={defaultColumnWidth}
          />

          <GridColumn
            field="serviceDate"
            title="Date Of Service"
            filter="date"
            format="{0:d}"
            width={DefaultDateColumnWidth()}
          />

          <GridColumn
            field="transactionDate"
            title="Transaction Date"
            filter="date"
            format="{0:d}"
            width={DefaultDateColumnWidth()}
          />

          <GridColumn
            field="placeOfServiceCode"
            title="Place Of Service Code"
            width={defaultColumnWidth}
          />

          <GridColumn
            field="pharmacyServiceTypeCode"
            title="Pharmacy Service Type Code"
            width={defaultColumnWidth * 1.5} // lets give this one a little more space due to long title
          />

          <GridColumn
            field="patientResidenceCode"
            title="Patient Residence Code"
            width={defaultColumnWidth}
          />

          <GridColumn
            field="quantityDispensed"
            title="Quantity Dispensed"
            filter="numeric"
            format="{0:n3}"
            width={defaultColumnWidth}
          />

          <GridColumn
            field="daySupply"
            title="Day Supply"
            filter="numeric"
            format="{0:n2}"
            width={defaultColumnWidth}
          />

          <GridColumn
            field="adjAmount"
            title="Adjudicated Amount"
            filter="numeric"
            format="{0:c}"
            width={defaultColumnWidth}
          />

          <GridColumn
            field="paidAmount"
            title="Paid Amount"
            filter="numeric"
            format="{0:c}"
            width={defaultColumnWidth}
          />

          <GridColumn
            field="dispensingFeePaid"
            title="Dispensing Fee Paid"
            filter="numeric"
            format="{0:c}"
            width={defaultColumnWidth}
          />

          <GridColumn field="scC1" title="SCC1" width={defaultColumnWidth} />

          <GridColumn field="scC2" title="SCC2" width={defaultColumnWidth} />

          <GridColumn field="scC3" title="SCC3" width={defaultColumnWidth} />

          <GridColumn
            field="submissionClarificationCodesCount"
            title="Count Of Submission Clarification Codes"
            width={defaultColumnWidth * 2} // lets give this one a little more space due to long title
          />

          <GridColumn
            field="specialPackageIndicator"
            title="Special Package Indicator"
            width={defaultColumnWidth * 1.5} // lets give this one a little more space due to long title
          />

          <GridColumn
            field="brandGenericCode"
            title="Brand/Generic Code"
            width={defaultColumnWidth}
          />

          <GridColumn field="ndc" title="NDC" width={defaultColumnWidth} />

          <GridColumn
            field="dispenseFeeSubmitted"
            title="Dispense Fee Submitted"
            filter="numeric"
            format="{0:c}"
            width={defaultColumnWidth}
          />

          <GridColumn
            field="ucSubmitted"
            title="U&C Submitted"
            filter="numeric"
            format="{0:c}"
            width={defaultColumnWidth}
          />

          <GridColumn
            field="gadSubmitted"
            title="GAD Submitted"
            filter="numeric"
            format="{0:c}"
            width={defaultColumnWidth}
          />

          <GridColumn
            field="awpSubmitted"
            title="AWP Submitted"
            filter="numeric"
            format="{0:c}"
            width={defaultColumnWidth}
          />

          {/* <GridColumn
            field="ignoreReason"
            title="Ignore Reason"
            width={defaultColumnWidth}
          /> */}
        </SharedMainSelectableClientGrid>
      </Col>
    </Row>
  );
}
